
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";
import { ElForm } from "element-ui/types/form";
import api from "@/api";
import { CreateOrEditDepartmentDto } from "@/api/appService";

@Component
export default class EditDepartment extends Vue {
  @Ref() readonly dataForm!: ElForm;

  @Prop({required:true})
  parentId!:number;

  get dialogTitle() {
    return this.form!.id ? "编辑" : "新建";
  }

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      await api.department.getForEdit({ id: this.form!.id }).then(res => {
        this.form = res.data!;
      });
    } else {
      this.form = { ...this.defaultData };
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  defaultData: CreateOrEditDepartmentDto = {
    displayName: undefined,
    desc: undefined,
    parentId: undefined,
    id: 0
  };

  show = false;
  form: CreateOrEditDepartmentDto = { ...this.defaultData };

  async save() {
    console.log(this.form);

    if(!this.form.id){
      if(this.parentId){
        this.form.parentId = this.parentId;
      } else {
        this.form.parentId = undefined;
      }
    }

    this.dataForm.validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.id) {
          await api.department.update({ body: this.form });
        } else {
          await api.department.create({ body: this.form });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.$emit("onSave");
      }
    });
  }

  // 图片上传前判断
  // async beforeAvatarUpload(file: any) {
  //   const isLt2M = file.size / 1024 / 1024 < 2;
  //   if (!isLt2M) {
  //     this.$message.error("上传头像图片大小不能超过 2MB!");
  //   }
  //   return isLt2M;
  // }

  // async handleAvatarSuccess(res: any, file: any) {
  //   console.log(res);
  //   if (res.success) {
  //     this.form.titleImageUrl = res.result;
  //   }
  // }

  cancel() {
    this.show = false;
  }

  roleRule = {
    displayName: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ]
  };
}
